const initialState = false;

const noti = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_NOTI':
            state = action.payload.noti
            return state;

        default:
            return state;
    }
};

export default noti;